import { PhotoIcon } from '@heroicons/react/24/solid';
import { memo } from 'react';

/**
 * Empty state component for when no images are found
 * @returns {JSX.Element} Empty state
 */
const EmptyState = () => {
  return (
    <div className="text-center py-8">
      <PhotoIcon className="w-12 h-12 mx-auto mb-4 text-cool-gray" />
      <p className="text-raisin-black dark:text-crystal-bell">
        No images found. Upload some images to see them here.
      </p>
    </div>
  );
};

export default memo(EmptyState);
